import { InventoryItemOutcome } from "@redotech/crdb-enums/inventory/inventory-item-outcome";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const listSupportedOutcomes = unaryRpc({
  name: "listSupportedOutcomes" as const,
  input: z.object({}),
  output: z.object({
    /** One entry per existing returns center available to the team. */
    returnsCenters: z.array(
      z.object({
        returnsCenterId: z.string(),
        /** Includes the outcomes every center supports. */
        supportedOutcomes: z.array(z.enum(InventoryItemOutcome)),
      }),
    ),
  }),
});
